import React from 'react';
import BackButtonIcon from '../../../../../../../../common/assets/svg/BackButtonIcon';

const BackButton = ({ onClick }) => (
  <div {...{ onClick }}>
    <BackButtonIcon />
  </div>
);

const Title = () => <h1 className="title">Visa Protection Plan</h1>;

const AddOnOverlayHeader = ({ onBackClick }) => (
  <div className="addon-overlay-header">
    <BackButton {...{ onClick: onBackClick }} />
    <Title />
  </div>
);

export default AddOnOverlayHeader;
